import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {flex: 1, alignItems: 'center', justifyContent: 'center'},
  title: {marginBottom: 10},
  message: {marginBottom: 20, marginHorizontal: 25, textAlign: 'center'},
});
